import * as React from 'react';

import { enumLoadStatus } from '@rematter/frontend-lib-api-client';
import { useSetAtom } from 'jotai';

import { $updateLoad } from '../../_state/loadDetail.state';

import { LoadRecord } from '~/modules/trade/types/load';
import { EntityTabNotes } from '~/shared/components/EntityTabNotes';

type Props = {
  load: LoadRecord;
};

export const LoadTabNotes: React.FC<Props> = ({ load }) => {
  const updateLoad = useSetAtom($updateLoad);

  const isReadonly =
    load.status === enumLoadStatus.Reconciled ||
    load.status === enumLoadStatus.Voided;

  const handleSave = React.useCallback(
    async (notes: {
      internalNotes: string;
      externalNotes: string;
    }): Promise<void> => {
      await updateLoad({
        id: load.id,
        heavyWeight: load.heavyWeight,
        lightWeight: load.lightWeight,
        recyclerInternalNotes: notes.internalNotes,
        recyclerExternalNotes: notes.externalNotes,
      });
    },
    [load.heavyWeight, load.id, load.lightWeight, updateLoad],
  );

  return (
    <EntityTabNotes
      key={load.id}
      className="@LoadTabNotes"
      counterparty="customer"
      isReadonly={isReadonly}
      internalNotes={load.recyclerInternalNotes ?? ''}
      externalNotes={load.recyclerExternalNotes ?? ''}
      onSave={handleSave}
    />
  );
};
